import reducer from '../utils/reducer'
import {ACTION_NAMES} from '../utils/actionConstants'

const initialState = {
  auth: null,
  loading: true
}

export default reducer(initialState, {
  [ACTION_NAMES.AUTH.REQUEST_AUTHENTICATION]: (state) => {
    return {
      ...state,
      loading: true
    }
  },
  [ACTION_NAMES.AUTH.REQUEST_AUTHENTICATION_ERROR]: (state, payload) => {
    return {
      ...state,
      error: payload,
      loading: false
    }
  },
  [ACTION_NAMES.AUTH.RECEIVE_AUTHENTICATION]: (state, payload) => {
    return {
      ...state,
      error: null,
      auth: payload,
      loading: false
    }
  },
  [ACTION_NAMES.AUTH.REQUEST_IMPERSONATION]: (state, payload) => {
    return {
      ...state,
      loading: false,
      error: false
    }
  },
  [ACTION_NAMES.AUTH.RECEIVE_IMPERSONATION]: (state, payload) => {
    return {
      ...state,
      auth: payload,
      loading: false
    }
  },
  [ACTION_NAMES.AUTH.RECEIVE_IMPERSONATION_ERROR]: (state, payload) => {
    return {
      ...state,
      loading: false,
      error: true
    }
  },
  [ACTION_NAMES.AUTH.CLEAR_AUTHENTICATION_ERROR]: (state, payload) => {
    return {
      ...state,
      error: false
    }
  },
  [ACTION_NAMES.AUTH.REQUEST_REMOVE_IMPERSONATION]: (state, payload) => {
    return {
      ...state,
      loading: true
    }
  },
  [ACTION_NAMES.AUTH.RECEIVE_REMOVE_IMPERSONATION]: (state, payload) => {
    return {
      ...state,
      auth: payload,
      loading: false
    }
  },
  [ACTION_NAMES.AUTH.LOGOUT_AUTHENTICATION]: (state, payload) => {
    return {
      ...state,
      auth: null,
      loading: false
    }
  }
})
